import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'arraySlice' })
export class ArraySlicePipe implements PipeTransform {

  /* transform(): Pipe que devuelve un listado recortado de acuerdo a los parámtros recibidos
    value: Listado a recortar
    start: Inicio del recorte
    slice: Cantidad a recortar
  */
  transform = (value: any[], start: number = 0, slice: number = 0): any[] => value.slice(start, slice);

}
